<div class="search-input-wrapper">
  <search-input-dumb
    [placeholder]="'Search for your template'"
    (searchClicked)="searchTemplateClicked($event)"
  ></search-input-dumb>
</div>
<!--<ul class="categories-list categories-list-top">
    <li class="categories-header">View by</li>
    <li>item 2</li>
    <li>item 2</li>
    <li>item 2</li>
    <li>item 2</li>
</ul>-->
<ul class="categories-list categories-list-bottom">
  <li class="categories-header">Categories</li>
  <li
    [ngClass]="{ active: !currentCategory }"
    [routerLink]="['/tenant/choose-template']"
    (click)="categoryClickedHandler(undefined)"
  >
    All Templates
  </li>
  <li
    *ngFor="let category of templateCategories"
    (click)="categoryClickedHandler(category)"
    [ngClass]="{ active: currentCategory && category.id == currentCategory.id }"
    [routerLink]="['/tenant/choose-template']"
    [queryParams]="{ categoryId: category.id }"
  >
    {{ category.displayName }}
  </li>
</ul>
